import { useAppSelector } from "src/state/store/store";
import { getReviewerNavigation } from "./ReviewerNavigation";
import { AuthorNavbar } from "./AuthorNavigation";
import { PublisherNavbar } from "./PublisherNavigation";
import { OpenNavigation } from "./OpenNavigation";
import { CNavBarItemT } from "./navigationType";
import { ApprovalStatus } from "src/enums/enums";

export const getNavigation = (type: String, approvalStatus: string) => {
  let navList: CNavBarItemT[] = [];
  if (type == "reviewer") {
    navList = getReviewerNavigation(approvalStatus);
  } else if (type == "author") {
    navList = AuthorNavbar;
  } else if (type == "publisher") {
    navList = PublisherNavbar;
  } else {
    navList = OpenNavigation;
  }
  return navList;
};
